/**
 * product-reviews
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_product-reviews.twig';
import './_product-reviews.css';

export const name = 'product-reviews';

export const defaults = {
  dummyClass: 'js-product-reviews-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { productReviews = {} }) {
  // Find our component within the DOM
  const $productReviews = $('.product-reviews', $context).once(
    'product-reviews--init'
  );

  // Bail if component does not exist
  if (!$productReviews.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...productReviews,
  };
  // An example of what could be done with this component
  $productReviews.addClass(settings.dummyClass);

  // Moves the summary below the product tagline.
  const $summaries = $productReviews.filter('.product-reviews--summary');
  $summaries.each(function relocateProductRatingSummary() {
    $('.product__tagline').after(this);
  });

  // Properly updates the progress bars to reflect a more accurate representation.
  $productReviews
    .filter('.product-reviews--breakdown')
    .each(function updateReviewsProgressBars() {
      const commentsTotal = parseInt(
        $(this)
          .parent()
          .find('.product-reviews__review-count')
          .attr('data-review-count'),
        10
      );
      $('.product-reviews__rating-count-bar', this).attr('max', commentsTotal);
    });
  /*
  // Hides webform by default.
  $('.product-reviews__review-count', context).each(function () {

    // Visually updates the progress.
    $('.product-reviews__rating-count-bar').attr('max', $(this).data('review-count')).each(function () {
      var progress = $(this).attr('value') / $(this).attr('max') * 100;
      var bar = $('<div class="product-reviews__rating-count-bar progress-bar"><div class="progress-bar__progress" style="width:' + progress + '%;"></div></div>')
      $(this).replaceWith(bar);
    });

  });
  */
}

export default enable;
